import { createFileRoute } from '@tanstack/react-router';
import { AppSelectorScreen } from '../screens/AppSelector';

export const Route = createFileRoute('/apps')({
  component: AppSelectorScreen,
});
